// extracted by mini-css-extract-plugin
export default {"Container":"Federal_Container__Gasg-","section-1":"Federal_section-1__NfOjr","content":"Federal_content__LtJoB","ul":"Federal_ul__MIKR+","section-2":"Federal_section-2__7BdGB"};